import type { ReactNode } from "react";
import { ChevronRight } from "lucide-react";

export interface ExplainableSectionProps {
  summary: string;
  question: string;
  children: ReactNode;
}

/** Authored block content; disclosure works before hydration and without JavaScript. */
export function ExplainableSection({
  summary,
  question,
  children,
}: ExplainableSectionProps) {
  return (
    <div className="my-6 space-y-3 text-neutral-800 dark:text-neutral-200">
      <p className="m-0! leading-relaxed">{summary}</p>
      <details className="group">
        <summary className="flex min-h-11 cursor-pointer list-none items-center gap-2 rounded-sm py-2 font-semibold text-rose-700 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-rose-500 dark:text-rose-300 [&::-webkit-details-marker]:hidden">
          <ChevronRight
            aria-hidden="true"
            className="h-4 w-4 shrink-0 transition-transform group-open:rotate-90 motion-reduce:transition-none"
          />
          <span>{question}</span>
        </summary>
        <div className="space-y-3 pt-2 leading-relaxed [&>p]:m-0!">
          {children}
        </div>
      </details>
    </div>
  );
}
